import React, { useEffect } from 'react'
import styled from '@emotion/styled'

const CloseContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: sans-serif;
  text-align: center;
  padding: 20px;
`

export const BillingCloseCallback: React.FC = () => {
  useEffect(() => {
    // Attempt to close the window
    window.close()
  }, [])

  return (
    <CloseContainer>
      <h3>Billing Portal Closed</h3>
      <p>You can close this window now.</p>
    </CloseContainer>
  )
}

